// generated by the plop

import { EnterpriseStateModel } from './enterprise.model';

export class GetEnterpriseList {
  static readonly type = '[Enterprise] Get Enterprise List';
}
